import { render, staticRenderFns } from "./EmployeeExitFiles.vue?vue&type=template&id=4c570ff4&"
import script from "./EmployeeExitFiles.vue?vue&type=script&lang=js&"
export * from "./EmployeeExitFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports